import { inject, observer } from "mobx-react";
import { useEffect } from "react";
import { useGetV4WarehousesQuery } from "randmar-api-client";
import withManufacturer from "../../contexts/WithManufacturer";
import { RootStore } from "../../stores/rootStore";

interface IProps {
  store?: RootStore;
  applicationId: string;
}

const GeneralTimer = ({ store, applicationId }: IProps) => {
  useGetV4WarehousesQuery();

  useEffect(() => {
    if (!applicationId) {
      return;
    }

    const { documentsStore, manufacturerStore, categoriesStore, returnsStore, opportunityStore, resellerStore, mediaStore } = store!;

    manufacturerStore.getManufacturerInfo(applicationId);
    documentsStore.getOpenOrders(applicationId);
    documentsStore.getRequisitions(applicationId);
    documentsStore.getPurchasesOrders(applicationId);
    documentsStore.getReceipts(applicationId);
    documentsStore.getInvoices(applicationId);
    manufacturerStore.getInventoryValue(applicationId);
    categoriesStore.getCategories(applicationId);
    returnsStore.getReturns(applicationId);
    opportunityStore.getOpportunities(applicationId);
    resellerStore.getResellers(applicationId);
    mediaStore.getAllScenes();

    const tenMinTimer = setInterval(() => {
      documentsStore.getOpenOrders(applicationId);
      manufacturerStore.getInventoryValue(applicationId);
    }, 600000);

    return () => {
      clearInterval(tenMinTimer);
    };
  }, [applicationId, store]);

  return null;
};

const AuthenticatedGeneralTimer = (props: IProps) => {
  const user = props.store!.userStore.user;

  if (user && user.access_token) {
    return <GeneralTimer {...props} />;
  }

  return null;
};

export default withManufacturer(inject('store')(observer(AuthenticatedGeneralTimer)));
